import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontSize12, Spacing4 } from 'autogen/design-tokens/tokens';
import type { ProductRegimeProductModel } from 'autogen/swagger/all';
import { SoldOutOnline } from 'autogen/translation-keys/trans-website-productregime';
import { BackInStockNotification } from 'autogen/translation-keys/trans-website-shared-buttons';
import InlineButton from 'components/generic/InlineButton/InlineButton';
import useNotificationFormQuickView from 'components/product/notification/shared/hooks/useNotificationFormQuickView';
import StockIndicator from 'components/shared/stockIndicator';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${Spacing4};
    font-size: ${FontSize12};

    span {
        margin: 0;
    }
`;

export default function SoldOutReminder({ product, ...restProps }: { product: ProductRegimeProductModel }) {
    const { t } = useTranslation();
    const [, toggle] = useNotificationFormQuickView();
    const {
        product: { primaryImage, id, listName }
    } = product;

    return (
        <Wrapper {...restProps}>
            <StockIndicator checkmarkType="Red" useDot />
            {t(SoldOutOnline)} -
            <InlineButton
                size="S"
                onClick={() =>
                    toggle({
                        isOpen: true,
                        notificationModel: {
                            productId: id,
                            email: '',
                            isPreorder: false,
                            image: primaryImage.url,
                            productName: listName
                        }
                    })
                }
            >
                {t(BackInStockNotification)}
            </InlineButton>
        </Wrapper>
    );
}
